import { Container, Divider, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { InputCheck } from "../../controls";
import * as actions from "../../api/actions/pos";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../App";
import { controller, endpoints } from "../../api/actions/api";
import SearchBox from "../pos/SearchBox";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { safeOnComplete } from "../../utils/safeOnComplete";

const PosSettings = (props) => {
  const { t } = useTranslation();
  const { _posItems, _getById, _set, _defStore, _post, _delete } = props;
  const { setLoader } = useContext(AppContext);
  const [posItem, setPosItem] = useState([]);

  useEffect(() => {
    setPosItem([]);
    if (_defStore.id) {
      setLoader(true);
      const onComplete = (res) => {
        _set(
          { result: res.result.map((j) => j.product) },
          actions.ActionType.SetPosItems
        );
        setLoader(false);
      };
      _getById(
        endpoints.Inventory + controller.GetProdsByStore,
        _defStore.id,
        null,
        onComplete
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_defStore]);

  useEffect(() => {
    const onComplete = safeOnComplete(
      (res) => {
        if (
          res.status === 200 &&
          Array.isArray(res.result) &&
          _posItems.length > 0
        ) {
          setPosItem(
            _posItems.map((j) => ({
              id: j.id,
              name: j.name,
              checked: res.result.some((x) => x.productId === j.id),
            }))
          );
        }
      },
      (err) => {
        console.error("Failed to load POS items:", err);
      }
    );
    _defStore.id &&
      _posItems?.length > 0 &&
      _getById(
        endpoints.PosItem + controller.GetByStoreId,
        _defStore.id,
        null,
        onComplete
      );
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_posItems]);

  const handleChange = (e, prodId) => {
    e.target.checked
      ? _post(
          endpoints.PosItem,
          ToFormData(RmvEmptyProp({ productId: prodId, storeId: _defStore.id }))
        )
      : _delete(endpoints.PosItem, prodId, null);
  };

  return (
    <Container maxWidth="md">
      <Paper className="br-8 shadow-xs p-20">
        <Box className="tx-center mb-20">
          <Typography variant="subtitle1" className="fs-22 fw-5 gray-color">
            {t("allItems")}
          </Typography>
          <div className="bs-bottom mx-w-60 m-auto" />
        </Box>
        <Box className="tx-center mb-20">
           <SearchBox type="product" />
        </Box>
        <Box
          sx={{
            height: "calc(100vh - 300px)",
            overflow: "auto",
            pr: "10px",
          }}
        >
          {posItem.map((prod, i) => (
            <Box key={i}>
              <InputCheck
                onChange={(e) => handleChange(e, prod.id)}
                label={prod.name}
                defaultChecked={prod.checked}
              />
              <Divider />
            </Box>
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  _posItems: state.pos.posItems,
  _defStore: state.pos.defStore,
});

const mapActionToProps = {
  _post: actions.post,
  _delete: actions.Delete,
  _getById: actions.getById,
  _set: actions.setVal,
};

export default connect(mapStateToProps, mapActionToProps)(PosSettings);
